import { format } from 'date-fns';

import { DocumentType, PlacementDocument } from './singleStudent.types';

export const groupDocumentsByMonth = (documents: PlacementDocument[]) => {
  const grouped: { [key: string]: PlacementDocument[] } = {};

  documents.forEach((document) => {
    const date = new Date(document.year, document.month - 1);
    const monthKey = format(date, 'MMMM yyyy');

    if (!grouped[monthKey]) {
      grouped[monthKey] = [];
    }
    grouped[monthKey].push(document);
  });

  return Object.keys(grouped)
    .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
    .map((monthKey) => ({
      month: monthKey,
      documents: grouped[monthKey],
    }));
};

export const getDocumentTypeName = (type: DocumentType) => {
  switch (type) {
    case 'ServiceCoordination':
      return 'Service Coordination';
    case 'Attendance':
      return 'Attendance';
    case 'Timesheet':
      return 'Timesheet';
    case 'CoordinationLog':
      return 'Coordination Log';
    case 'Invoice':
      return 'Invoice';
    case 'SessionNotes':
      return 'Session Notes';
    default:
      return 'Document';
  }
};
